export const tipoOleriteOptions = [
  { id: 'HOLERITE', nome: 'Holerite' },
  { id: 'INFORME_RENDIMENTO', nome: 'Informe de Rendimento' },
  { id: 'FERIAS', nome: 'Férias' },
];

export const isInformeRendimento = (tipo) => tipo === 'INFORME_RENDIMENTO';

export const getMesReferenciaLabel = (tipo) =>
  isInformeRendimento(tipo) ? 'Ano de Referência' : 'Mês Referência';

export const getTipoOleriteLabel = (tipo) => {
  const found = tipoOleriteOptions.find((item) => item.id === tipo);
  return found ? found.nome : tipo || '—';
};
